/* eslint-disable */
import React from 'react';
import styles from './style.module.scss';
import { useNav } from '../../../hooks/nav';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import { useStore } from 'src/onboarding/store/store';

import DefaultImage from '../../../assets/images/recipes-transition.webp';
import VeganImage from '../../../assets/images/vegan-recipes-transition.webp';
import VegetarianImage from '../../../assets/images/vegetarian-recipes-transition.webp';
import PescatarianImage from '../../../assets/images/pescatarian-recipes-transition.webp';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const preferences = useStore((state) => state.preferences);

  const isFirst = currentIndex === 0;

  const CONTENT_BY_PREFERENCE = {
    Vegan: {
      image: VeganImage,
      title: t('onboarding.recipesTransition.vegan.title'),
      text: t('onboarding.recipesTransition.vegan.text'),
    },
    Vegetarian: {
      image: VegetarianImage,
      title: t('onboarding.recipesTransition.vegetarian.title'),
      text: t('onboarding.recipesTransition.vegetarian.text'),
    },
    Pescatarian: {
      image: PescatarianImage,
      title: t('onboarding.recipesTransition.pescatarian.title'),
      text: t('onboarding.recipesTransition.pescatarian.text'),
    },
  };

  const DEFAULT_CONTENT = {
    image: DefaultImage,
    title: t('onboarding.recipesTransition.default.title'),
    text: t('onboarding.recipesTransition.default.text'),
  };

  const getContent = () => {
    if (!preferences || preferences === 'No any preferences') {
      return DEFAULT_CONTENT;
    }

    return CONTENT_BY_PREFERENCE[preferences] || DEFAULT_CONTENT;
  };

  const content = getContent();

  return (
    <div className={`page ${styles.top}`} style={{ gap: 0 }}>
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className={styles.image} style={{ backgroundImage: `url(${content.image})` }} />

      <div className={'wrapper-info'} style={{ paddingBottom: 90 }}>
        <Title tag='h2'>{content.title}</Title>

        <Text semibold className={styles.description} style={{ marginTop: 16 }}>
          {content.text}
        </Text>

        <div className={'overlay'}></div>
      </div>
      <div className={'next-wrapper'}>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'recipes-transition',
            });
            onNext();
          }}
          title={t('onboarding.recipesTransition.continue')}
        />
      </div>
    </div>
  );
}

export default Page;
